import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import { useApi } from './use-api';
export function withApi(BaseComponent) {
    const WithApi = (props) => {
        const api = useApi();
        return React.createElement(BaseComponent, Object.assign({}, props, { api: api }));
    };
    hoistNonReactStatics(WithApi, BaseComponent);
    WithApi.displayName = `WithApi(${getDisplayName(BaseComponent)})`;
    return WithApi;
}
function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
//# sourceMappingURL=with-api.js.map